function padNumber(value: number) {
    return value < 10 ? '0' + value : value;
}

export default padNumber;
